import { Box, HStack, Text, VStack } from "@chakra-ui/react"
import Dialog from "@hydrologiq/shared/chakra/Dialog"
import { ActionButton } from "@hydrologiq/shared/content/components/Button"

interface DeleteMappingDialogProps {
  open: boolean
  assetName: string
  sourceLabel: string
  onConfirm: () => void
  onClose: () => void
  loading?: boolean
}

export function DeleteMappingDialog({
  open,
  assetName,
  sourceLabel,
  onConfirm,
  onClose,
  loading = false,
}: DeleteMappingDialogProps) {
  return (
    <Dialog
      title="Remove mapping"
      open={open}
      setOpen={(isOpen) => {
        if (!isOpen) onClose()
      }}
      onClose={onClose}
      footer={
        <HStack gap={3}>
          <ActionButton
            onClick={onClose}
            disabled={loading}
            context={{
              label: "Cancel",
              description: "Cancel removal",
              variant: "secondary",
            }}
          />
          <ActionButton
            onClick={onConfirm}
            loading={loading}
            disabled={loading}
            context={{
              label: "Remove",
              description: "Remove this mapping",
              variant: "warning",
            }}
          />
        </HStack>
      }
    >
      <VStack align="stretch" gap={3}>
        <Box borderWidth="1px" borderRadius="md" p={3} bg="bg.subtle">
          <VStack align="stretch" gap={1}>
            <Text fontWeight="semibold" fontSize="sm">
              {assetName}
            </Text>
            <Text fontSize="sm" color="fg.muted">
              Source: {sourceLabel}
            </Text>
          </VStack>
        </Box>
        <Text>
          Removing this mapping will stop{" "}
          <Text as="span" fontWeight="semibold">
            {assetName}
          </Text>{" "}
          from pulling data from{" "}
          <Text as="span" fontWeight="semibold">
            {sourceLabel}
          </Text>
          .
        </Text>
        <Text fontSize="sm" color="fg.muted">
          You can re-map this asset to a different source at any time.
        </Text>
      </VStack>
    </Dialog>
  )
}

export default DeleteMappingDialog
